import { render, staticRenderFns } from "./maintenanceRecord.vue?vue&type=template&id=13a6ba63&scoped=true&"
import script from "./maintenanceRecord.vue?vue&type=script&lang=js&"
export * from "./maintenanceRecord.vue?vue&type=script&lang=js&"
import style0 from "./maintenanceRecord.vue?vue&type=style&index=0&id=13a6ba63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6ba63",
  null
  
)

export default component.exports